import { ExclamationCircleFilled } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
export { Modal } from 'antd';
// We access the theme statically because the modals are rendered
// through a portal, so the ThemeProvider is not accessible
const StyledExclamationCircleFilled = styled(ExclamationCircleFilled) `
  color: ${theme.colors.coral};
`;
export function modalInfo(props) {
    Modal.info({
        okText: 'Ok',
        ...props,
        okButtonProps: {
            type: 'primary',
            shape: 'round',
            ...props.okButtonProps,
        },
    });
}
export function modalConfirm(props) {
    Modal.confirm({
        okText: 'Confirm',
        cancelText: 'Cancel',
        ...props,
        okButtonProps: {
            type: 'primary',
            shape: 'round',
            ...props.okButtonProps,
        },
        cancelButtonProps: {
            type: 'default',
            shape: 'round',
            ...props.cancelButtonProps,
        },
    });
}
export function modalDanger(props) {
    Modal.confirm({
        icon: React.createElement(StyledExclamationCircleFilled, null),
        okText: 'Confirm',
        okType: 'danger',
        cancelText: 'Cancel',
        ...props,
        okButtonProps: {
            danger: true,
            shape: 'round',
            ...props.okButtonProps,
        },
        cancelButtonProps: {
            type: 'default',
            shape: 'round',
            ...props.cancelButtonProps,
        },
    });
}
export const ModalFooterContainer = styled.div `
  display: flex;
  justify-content: flex-end;
  margin: 0 -24px -8px;
  padding: 18px 24px 0;
`;
export const ModalCancelButton = styled(Button) `
  min-width: 112px;
`;
export const ModalSubmitButton = styled(ModalCancelButton) `
  margin-left: 12px;
`;
